import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchOwnServices } from '@/api/services/servicesApi';
import type { OwnerService } from '@/api/services/servicesApi.types';
import { OWN_SERVICES_QUERY_KEY } from '@/constants/queryKeys';

export function useOwnServicesQuery(enabled: boolean): UseQueryResult<OwnerService[], Error> {
  return useQuery({
    queryKey: OWN_SERVICES_QUERY_KEY,
    queryFn: fetchOwnServices,
    enabled,
  });
}
